<div class="modal-container p-6">
  <div class="modal-top">
    <h2 mat-dialog-title>
      {{ staffMember().name }}
    </h2>
    <div class="close-btn">
      <app-ui-icon (click)="closeDialog()" color="var(--blue-3)" name="close" size="md"></app-ui-icon>
    </div>
  </div>

  <div
    [innerHTML]="staffMember().description"
    class="modal-content py-4"
    mat-dialog-content
  ></div>

  <div class="modal-actions" mat-dialog-actions>
    <app-ui-button
      (click)="closeDialog()"
      color="tertiary"
      expanded="block"
      size="md"
    >Stäng
    </app-ui-button
    >
  </div>
</div>
